import { createReducer, on } from '@ngrx/store';
import { TrackerSettingsActions } from '../actions';
import { trackerState } from '../tracker.state';
import { TrackerGoalQuery } from '../tracker.state.interface';

// Settings action handlers - these return `on` functions that can be used in createReducer
export const trackerSettingsHandlers: Array<
  Parameters<typeof createReducer<typeof trackerState>>[1]
> = [
  on(TrackerSettingsActions.fetchUserHealthCategorySettings, (state) => ({
    ...state,
    userHealthCategorySettings: {
      ...state.userHealthCategorySettings,
      loading: true,
      error: undefined,
      fetchCount: state.userHealthCategorySettings.fetchCount + 1
    }
  })),
  on(
    TrackerSettingsActions.fetchUserHealthCategorySettingsSuccess,
    (state, payload) => ({
      ...state,
      userHealthCategorySettings: {
        ...state.userHealthCategorySettings,
        loading: false,
        error: undefined,
        data: payload.data
      }
    })
  ),
  on(
    TrackerSettingsActions.fetchUserHealthCategorySettingsFailed,
    (state, payload) => ({
      ...state,
      userHealthCategorySettings: {
        ...state.userHealthCategorySettings,
        loading: false,
        error: payload.error
      }
    })
  ),
  on(TrackerSettingsActions.fetchStepsGoalQuery, (state) => ({
    ...state,
    stepsGoalQuery: {
      ...state.stepsGoalQuery,
      loading: true,
      error: undefined,
      fetchCount: state.stepsGoalQuery.fetchCount + 1
    }
  })),
  on(TrackerSettingsActions.fetchStepsGoalQuerySuccess, (state, payload) => ({
    ...state,
    stepsGoalQuery: {
      ...state.stepsGoalQuery,
      loading: false,
      data: payload.data,
      error: undefined
    }
  })),
  on(TrackerSettingsActions.fetchUserDisclaimerAgreed, (state) => {
    return {
      ...state,
      userDisclaimerAgreedQuery: {
        ...state.userDisclaimerAgreedQuery,
        loading: true,
        fetchCount: state.userDisclaimerAgreedQuery.fetchCount + 1
      }
    };
  }),
  on(
    TrackerSettingsActions.fetchUserDisclaimerAgreedSuccess,
    (state, payload) => {
      return {
        ...state,
        userDisclaimerAgreedQuery: {
          ...state.userDisclaimerAgreedQuery,
          loading: false,
          agreedAt: payload.userAgreedAt
        }
      };
    }
  ),
  on(
    TrackerSettingsActions.fetchUserDisclaimerAgreedFailed,
    (state, payload) => {
      return {
        ...state,
        userDisclaimerAgreedQuery: {
          ...state.userDisclaimerAgreedQuery,
          loading: false,
          error: payload.error
        }
      };
    }
  ),
  on(TrackerSettingsActions.fetchLastPairedTracker, (state) => {
    return {
      ...state,
      lastPairedTrackerQuery: {
        ...state.lastPairedTrackerQuery,
        loading: true,
        fetchCount: state.lastPairedTrackerQuery.fetchCount + 1
      }
    };
  }),
  on(TrackerSettingsActions.fetchLastPairedTrackerSuccess, (state, payload) => {
    return {
      ...state,
      lastPairedTrackerQuery: {
        ...state.lastPairedTrackerQuery,
        loading: false,
        lastPairedAt: payload.lastPairedAt
      }
    };
  }),
  on(TrackerSettingsActions.fetchLastPairedTrackerFailed, (state, payload) => {
    return {
      ...state,
      userDisclaimerAgreedQuery: {
        ...state.userDisclaimerAgreedQuery,
        loading: false,
        error: payload.error
      }
    };
  }),
  on(TrackerSettingsActions.fetchTrackerGoal, (state, payload) => {
    const goalIndex = state.goalsQuery.findIndex(
      (goal) => goal.type === payload.tracker
    );

    const updatedGoals =
      goalIndex !== -1
        ? state.goalsQuery.map((goal, idx) =>
            idx === goalIndex
              ? { ...goal, queryLoading: true, queryError: undefined }
              : goal
          )
        : [
            ...state.goalsQuery,
            {
              type: payload.tracker,
              queryLoading: true,
              queryError: undefined,
              data: { goalScore: undefined, goalUnit: undefined }
            }
          ];

    return { ...state, goalsQuery: updatedGoals };
  }),
  on(TrackerSettingsActions.fetchTrackerGoalSuccess, (state, payload) => {
    const goalIndex = state.goalsQuery.findIndex(
      (goal) => goal.type === payload.tracker
    );
    const goalData: TrackerGoalQuery = {
      type: payload.tracker,
      queryLoading: false,
      queryError: undefined,
      data: {
        goalScore: payload.data.goalScore,
        goalUnit: payload.data.goalUnit
      }
    };

    const updatedGoals =
      goalIndex !== -1
        ? state.goalsQuery.map((goal, idx) =>
            idx === goalIndex ? { ...goal, ...goalData } : goal
          )
        : [...state.goalsQuery, goalData];

    return { ...state, goalsQuery: updatedGoals };
  }),
  on(TrackerSettingsActions.fetchTrackerGoalFailed, (state, payload) => {
    const goalIndex = state.goalsQuery.findIndex(
      (goal) => goal.type === payload.tracker
    );
    const goalData: TrackerGoalQuery = {
      type: payload.tracker,
      queryLoading: false,
      queryError: payload.error,
      data: { goalScore: undefined, goalUnit: undefined }
    };

    const updatedGoals =
      goalIndex !== -1
        ? state.goalsQuery.map((goal, idx) =>
            idx === goalIndex
              ? { ...goal, queryLoading: false, queryError: payload.error }
              : goal
          )
        : [...state.goalsQuery, goalData];

    return { ...state, goalsQuery: updatedGoals };
  })
];
